import { render, staticRenderFns } from "./currency_selector.vue?vue&type=template&id=c866dfb4&"
import script from "./currency_selector.vue?vue&type=script&lang=js&"
export * from "./currency_selector.vue?vue&type=script&lang=js&"
import style0 from "./currency_selector.vue?vue&type=style&index=0&id=c866dfb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports